import React, { useState } from 'react';
import { Alert } from '@wienenergiegithub/ui-next';

const CmsAlert = ({
  headingLevel,
  title,
  details,
  variant,
  icon,
  hasCloseButton,
}) => {
  const [show, setShow] = useState(true);
  const handleClose = () => {
    setShow(false);
  };

  if (!show) {
    return null;
  }

  return (
    <Alert
      details={details}
      handleClose={handleClose}
      hasCloseButton={hasCloseButton}
      headingLevel={headingLevel}
      icon={icon}
      title={title}
      type={variant}
    />
  );
};

export default CmsAlert;
